import { Button, Loader, } from "@bracket/ui";
import { Conditional, TimeWall, } from "@components";
import { formatWEI, } from "@formatters";
import { useVaults, } from "@store";
import type { FunctionComponent, } from "react";
import styled from "styled-components";
import { MetricCard, } from "../../components/MetricCard";
import { MiddleSection } from "./MiddleSection";



export const Nav: FunctionComponent = () => {

	const {
		ready,
		activeAdminVault,
		claimManagementPerformanceFees,
		claimManagementTvlFees,
		claimManagementFees,
		claimBrktTvlFees,
	} = useVaults();

	if(!ready)
		return <Loader />;

	if(!activeAdminVault)
		throw new Error("no active admin vault found");


	const {
		epoch,
		denomination,
		version,
		denomination: {
			label,
			symbol,
			decimals,
		},
		mgmt: {
			accruedManagerPerformanceFees,
			accruedManagerTvlFees,
			accruedBrktTvlFees,
			managerBalances,
			nextEpochStartTime,
		}
	} = activeAdminVault;

	const denoBalance = managerBalances.find(curr => curr.symbol === symbol);

	return (
		<Container>
			<CardContainer>
				<MetricCard title="Next Epoch" token={denomination} tooltipMessage="Date of the next epoch"
					value={ <TimeWall time={nextEpochStartTime} size="xl" /> } />
				<MetricCard title="Current Epoch" token={denomination} tooltipMessage="The current epoch of this vault"
					value={epoch} />
				<MetricCard title="Wallet Balance" token={denomination} tooltipMessage="Available balance of the denominating currency in the active wallet"
					value={formatWEI(denoBalance?.value.toString() || "0", decimals, symbol === "USDC" ? 2 : 5, true)} />
			</CardContainer>

			<CardContainer>
				<Conditional condition={version === null}>
					<MetricCard title={`Fixed Fees Accrued, ${label}`} token={denomination} tooltipMessage={`Fixed fees due to manager shown in ${label}`}
						value={formatWEI(accruedManagerTvlFees.toString(), decimals, symbol === "USDC" ? 2 : 5, true)}
						actionButton={<Button variant="primary-outline" label="Claim Fees" onClick={() => claimManagementTvlFees()} /> } />
					<MetricCard title={`Variable Fees Accrued, ${label}`} token={denomination} tooltipMessage={`Variable fees due to the manager in ${label}`}
						value={formatWEI(accruedManagerPerformanceFees.toString(), decimals, symbol === "USDC" ? 2 : 5, true)}
						actionButton={ <Button variant="primary-outline" label="Claim Fees" onClick={() => claimManagementPerformanceFees()} /> } />
				</Conditional>
				<Conditional condition={version !== null}>
					<MetricCard title={`Manager Fees Accrued, ${label}`} token={denomination} tooltipMessage={`Accrued fees due to manager shown in ${label}`}
						value={formatWEI((accruedManagerTvlFees + accruedManagerPerformanceFees).toString(), decimals, symbol === "USDC" ? 2 : 5, true)}
						actionButton={ <Button variant="primary-outline" label="Claim Fees" onClick={() => claimManagementFees()} /> } />
				</Conditional>
				<MetricCard title={`Bracket Fees Accrued, ${label}`} token={denomination} tooltipMessage={`Variable fees due to the manager in ${label}`}
					value={formatWEI(accruedBrktTvlFees.toString(), decimals, symbol === "USDC" ? 2 : 5, true)}
					actionButton={ <Button variant="primary-outline" label="Claim Fees" onClick={() => claimBrktTvlFees()} /> } />
			</CardContainer>

			<MiddleSection />
		</Container>
	);

};

const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 32px;
`;


const CardContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 8px;
	@media (min-width: 768px) {
		display: flex;
		gap: 12px;
		> * {
			flex: 1;
			width: 100%;
		}
	}
`;
